import React from 'react';
import AppBuilderPage from 'builders/builderApp/configMode/Page';

export default function index() {
    return (
        <AppBuilderPage />
    );
}
